/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function ArrowUUpRight(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8.0001,8.0001,0,0,1,13.65723-5.65674l48,48a8,8,0,0,1,0,11.31348l-48,48A8.0001,8.0001,0,0,1,168,136Z" />
    </Svg>
  );
}

export default ArrowUUpRight;
